module.exports = __webpack_public_path__ + "img/26.145fc2d7.png";